import { render } from "./UserCard.vue?vue&type=template&id=908c92aa&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=908c92aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908c92aa"]])

export default __exports__